/* eslint-disable no-unused-vars */

import { useState } from 'react';
import DeleteCurrentVersionDialog from './DeleteCurrentVersionDialog';
import UseCurrentVersionDialog from './UseCurrentVersionDialog';

export default function NavBar({ title, currentVersion, handleClose, getDocumentVersions }) {
    const [isUseCurrentVersionDialogOpen, setIsUseCurrentVersionDialogOpen] = useState(false);
    const [isDeleteCurrentVersionDialogOpen, setIsDeleteCurrentVersionDialogOpen] = useState(false);

    return (
        <>
            <div className="border-b border-[#F1F5F9] !px-6 !py-4 flex items-center justify-between">
                <div className="flex items-center !gap-6">
                    <img
                        src="/img/automated-scan/arrow-left-icon.svg"
                        alt="arrow-left-icon"
                        onClick={handleClose}
                        className="cursor-pointer object-contain"
                    />

                    <h3 className="text-[#002C72] capitalize font-bold text-lg">{title}</h3>
                </div>

                {currentVersion && (
                    <div className="flex items-center !gap-1">
                        {!currentVersion?.current && (
                            <button
                                className="transition-all hover:brightness-95 bg-[#F1F5F9] !border !border-[#E2E8F0] !rounded !py-1.5 !px-2 text-[#334155] font-medium text-sm"
                                onClick={() => setIsUseCurrentVersionDialogOpen(true)}
                            >
                                Use as current version
                            </button>
                        )}

                        <button
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                            className="transition-all hover:brightness-95 bg-white !rounded-lg !border !border-[#E2E8F0] !py-1 !px-1.5 flex items-center disabled:opacity-50 disabled:pointer-events-none"
                            id="download-policy-button"
                        >
                            <img src="/img/frameworks/download.svg" alt="download" className="!w-5 !h-5" />
                        </button>

                        {!currentVersion?.current && (
                            <button
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setIsDeleteCurrentVersionDialogOpen(true);
                                }}
                                className="transition-all hover:brightness-95 bg-white !rounded-lg !border !border-[#E2E8F0] !py-1 !px-1.5 flex items-center"
                            >
                                <img src="/img/risk-assessment/trash.svg" alt="download" className="!w-5 !h-5" />
                            </button>
                        )}
                    </div>
                )}
            </div>

            <UseCurrentVersionDialog
                isOpen={isUseCurrentVersionDialogOpen}
                setIsOpen={setIsUseCurrentVersionDialogOpen}
                currentVersion={currentVersion}
                getDocumentVersions={getDocumentVersions}
            />

            <DeleteCurrentVersionDialog
                isOpen={isDeleteCurrentVersionDialogOpen}
                setIsOpen={setIsDeleteCurrentVersionDialogOpen}
                currentVersion={currentVersion}
                getDocumentVersions={getDocumentVersions}
            />
        </>
    );
}
